<template>
  <v-list-item :disabled="itemDisabled" :to="{name: item.route}" exact>
    <v-list-item-action>
      <v-icon :style="{'color': item.color}">{{item.icon}}</v-icon>
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-title>{{item.title}}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  props: {
    itemData: {
      required: true,
      type: Object
    },
    itemDisabled: {
      required: false,
      type: Boolean
    }
  },
  data () {
    return {
      item: null
    }
  },
  created () {
    this.item = { ...this.itemData }
  }
}
</script>
